<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M83 27V64H44" stroke="black" stroke-width="4"/>
<path d="M44.001 54L22 64.1926L44.001 73.1111L44.001 63.5556L44.001 54Z" stroke="#000000" stroke-width="4" stroke-linecap="round"/>
</svg>

</template>
